module.exports = __webpack_public_path__ + "static/media/Hoist_ios_6_preview.4b8b111d.jpg";